import type { MutableRefObject } from 'react';

export const SNAP_PX = 8;
export const MIN_PPS = 1;
export const MAX_PPS = 400;
export const RULER_H = 26;

export const TICK_STEPS = [0.1, 0.25, 0.5, 1, 2, 5, 10, 15, 30, 60, 120, 300, 600, 1800, 3600];

// lane DOM nodes by track id — measured at clip-drag start for vertical moves
export type LaneRefs = MutableRefObject<Map<string, HTMLDivElement>>;

export type DragMode = 'move' | 'trim-l' | 'trim-r';

/** Vertical extent of a same-kind lane, measured once at drag start. */
export interface LaneBand {
  trackId: string;
  top: number;
  bottom: number;
}
